var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{staticClass:"sal-components-stock-quote-bottom"},[(_vm.canShowEqsvSustainability)?_c('sal-components-eqsv-sustainability',{staticClass:"sal-components-eqsv-sustainability__wrapper sal-component",attrs:{"hide-chiclet":"","mwc-id":"salEqsvSustainability"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }